<template>
  <div class="container">
    <ExternalQueryList
        endpoint="/api/v2/people"
        :endpoint-filters="{company_id: company.data.id}"
        :headlines="headlines"
        :can-update="() => true"
        @show="person => $router.push('/people/'+person.id)"
    >
      <template v-slot:default="{ row: person }">
        <td>
          <router-link :to="'/people/' + person.id">
            {{ person.attributes.name }}
          </router-link>

          <span v-if="company.data.advertising_contact_id === person.id" class="label label-info">
            Advertising Contact
          </span>

          <span v-if="company.data.subscription_contact_id === person.id" class="label label-success">
            Subscription Contact
          </span>

          <span v-if="person.attributes.has_partner_access" class="label label-success">
            Partner Access
          </span>

          <div class="pull-right">
            <i v-if="person.attributes.has_active_membership" class="fa fa-book-reader" v-tooltip="'Current Member'"></i>

            <i v-else-if="person.attributes.has_membership" class="fa fa-book-reader" v-tooltip="'Expired/Trial Member'" style="opacity: 0.2"></i>

            <i v-else class="fa fa-book-reader" style="opacity: 0"></i>
          </div>
        </td>

        <td>
            {{ person.attributes.email }}
        </td>
      </template>
    </ExternalQueryList>
  </div>
</template>

<script>
import ExternalQueryList from '@/components/Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  model: {
    prop: 'company',
  },

  props: {
    company: {
      required: true,
    }
  },

  computed: {
    headlines() {
      return [
        {width: 11, text: 'Name'},
        {width: 11, text: 'Email'},
      ]
    },
  }
}
</script>
